import { Injectable } from '@angular/core';

import * as momentNs from 'moment-timezone';
const moment = momentNs;

import { CalendarSlideService } from './calendar.slide.service';

export const TIMEZONE = 'Europe/London';

@Injectable()
export class CalendarDataService {
    meridiem = moment().tz(TIMEZONE).format('A');

    constructor(private calSlideService: CalendarSlideService) {}

    getIndexForTimes(timeRange: Array<string>): void {
        const nowHour = moment().tz(TIMEZONE).format('HH:mm').substring(0, 2);
        timeRange.map((time, i) => {
            const timeMod = time.substring(0, 2);
            if (timeMod >= '12' && this.calSlideService.indexForNoon === 0) this.calSlideService.indexForNoon = i;
            if (timeMod === nowHour && this.calSlideService.indexFromStart === 0 ||
                timeMod > nowHour && this.calSlideService.indexFromStart === 0) {
                this.calSlideService.indexFromStart = i;
            }
        });
    }
}
